import { useState, useEffect } from "react";
import {
  fetchAllParkingTypes,
  getVehicleType,
} from "../../../api/parkingTypes";
import { fetchAllSlotsWithoutFloor } from "../../../api/slots";
import { useParams } from "react-router-dom";

const useAvailableSlot = () => {
  let tenantId = localStorage.getItem("tenantId");
  let locationId = localStorage.getItem("locationId");
  const { vehicleType } = useParams();

  // const [parkingTypeId, setParkingTypeId] = useState("");
  const [slotCount, setSlotCount] = useState("");
  const [vehicleDetails, setVehicleDetails] = useState("");

  const handleClear = () => {
    setSlotCount("");
    setVehicleDetails("");
  };

  // Get All parking Type
  const getParkingType = async () => {
    let response = await fetchAllParkingTypes(locationId, tenantId);
    if (response) {
      findRegular(response);
    }
    return response;
  };

  const findRegular = async (response) => {
    const selectedParkingType = response?.find((val) => {
      return !val.deleted && val.name.trim().toLowerCase() === "regular";
    });
    // setParkingTypeId(selectedParkingType?.id);
    const resp = await getVehicleType(locationId, tenantId);
    const vehichleTypeData = resp.find((val) => {
      return Object.values(val)
        .join(" ")
        .toLowerCase()
        .includes(vehicleType.toLowerCase());
    });
    if (selectedParkingType?.id && vehichleTypeData?.id) {
      setVehicleDetails({
        ...vehichleTypeData,
      });
      getSlotCounts(selectedParkingType?.id, vehichleTypeData?.id);
    } else {
      handleClear();
    }
  };

  // Get Slot counts
  const getSlotCounts = async (parkingTypeId, vehicleTypeId) => {
    let response = await fetchAllSlotsWithoutFloor(
      tenantId,
      locationId,
      vehicleTypeId,
      parkingTypeId
    );
    setSlotCount(response);
    return response;
  };

  useEffect(() => {
    const interval = setInterval(() => {
      getParkingType();
    }, 30000);

    getParkingType();

    return () => {
      clearInterval(interval);
    };

    // eslint-disable-next-line
  }, [locationId, tenantId, vehicleType]);

  return { slotCount, vehicleDetails };
};

export default useAvailableSlot;
